export const SelectableTableUtils = {
  DefaultSelectItem<keyType>(itemKeys: keyType[], itemKeyToUpdate: keyType): keyType[] {
    const indexOf = itemKeys.indexOf(itemKeyToUpdate);
    if (indexOf >= 0) {
      const itemKeysArray = [...itemKeys];
      itemKeysArray.splice(indexOf, 1);
      return itemKeysArray;
    } else {
      return [...itemKeys, itemKeyToUpdate];
    }
  },
  DefaultSelectItems<keyType>(itemKeys: keyType[], itemKeysToUpdate: keyType[]): keyType[] {
    const itemKeysAreToBeRemoved = itemKeysToUpdate.every((x) => itemKeys.includes(x));
    if (itemKeysAreToBeRemoved) {
      return [...itemKeys.filter((x) => !itemKeysToUpdate.includes(x))];
    }

    const itemKeysToAdd = itemKeysToUpdate.filter((x) => !itemKeys.includes(x));
    return [...itemKeys, ...itemKeysToAdd];
  },
  DefaultTableItemsUpdated<keyType>(selectedItemKeys: keyType[], updatedTableItemKeys: keyType[]): keyType[] {
    return selectedItemKeys.filter((x) => updatedTableItemKeys.includes(x));
  }
};
